import { AgreementType } from './AgreementType'
import { DropdownOption } from '@urbanx/agx.ui-components2'

export const AgreementTypeOptions: DropdownOption[] = [
  {
    value: AgreementType.Custom,
    label: AgreementType.Custom,
  },
  {
    value: AgreementType.Default,
    label: AgreementType.Default,
  },
]
